import {
    CLASSIFICATION_SUBTYPE,
    CLASSIFICATION_TYPE,
    CONTACT_DETAILS_ID,
    DASHBOARD_ID,
    DASHBOARD_SECTION,
    DICTIONARY_ITEM_ID,
    DICTIONARY_NAME,
    FAQ_ID, FRAUD_REPORT_ID,
    FRAUD_REPORT_TYPE,
    INCIDENT_ID,
    KNOWLEDGE_DOCUMENT_ID,
    MSISDN_FRAUD_ENTRY_ID,
    MSISDN_ID,
    ORGANIZATION_DOCUMENT_ID,
    ORGANIZATION_ID,
    REFUND_ID,
    SUBJECT_ID,
    TRANSACTION_ID, TREND_ID,
    USER_ID,
} from './domain/query-params.keys';

export enum Path {
    ROOT = '',
    LOGIN = 'login',
    PASSWORD_RECOVERY = 'login/recovery',
    RESET_PASSWORD = 'reset-password',
    ANALYTICS = 'analytics',
    ANALYTICS_INCIDENTS_DASHBOARDS = `analytics/incidents/:${DASHBOARD_SECTION}`,
    ANALYTICS_INCIDENTS_DASHBOARD_CREATE = `${ANALYTICS_INCIDENTS_DASHBOARDS}/create-dashboard`,
    ANALYTICS_INCIDENTS_DASHBOARD_EDIT = `${ANALYTICS_INCIDENTS_DASHBOARDS}/:${DASHBOARD_ID}/edit-dashboard`,
    ANALYTICS_CLASSIFICATIONS_FRAUD = 'analytics/classification/classification-fraud',
    ANALYTICS_CLASSIFICATIONS_FRAUD_DETAILS = `${ANALYTICS_CLASSIFICATIONS_FRAUD}/:${CLASSIFICATION_TYPE}/:${CLASSIFICATION_SUBTYPE}`,
    ANALYTICS_CLASSIFICATIONS_FRAUD_DETAILS_EDIT = `${ANALYTICS_CLASSIFICATIONS_FRAUD_DETAILS}/edit-classification`,
    ANALYTICS_FRAUD_REPORTS = `analytics/fraud-reports/:${FRAUD_REPORT_TYPE}`,
    ANALYTICS_FRAUD_REPORT_DETAILS = `${ANALYTICS_FRAUD_REPORTS}/:${FRAUD_REPORT_ID}`,
    ANALYTICS_TRENDS = 'analytics/trends',
    ANALYTICS_TREND_DETAILS = `${ANALYTICS_TRENDS}/:${TREND_ID}`,
    ANALYTICS_TREND_DETAILS_CONCLUSION = `${ANALYTICS_TREND_DETAILS}/conclusion`,
    ANALYTICS_TREND_DETAILS_RATE = `${ANALYTICS_TREND_DETAILS}/rate`,
    ANALYTICS_TREND_EDIT = `${ANALYTICS_TREND_DETAILS}/edit-trend`,
    ADMIN_PANEL = 'admin-panel',
    USERS = 'users',
    DICTIONARIES = 'dictionaries',
    ADMIN_PANEL_USERS = `admin-panel/${USERS}`,
    ADMIN_PANEL_USERS_EDIT = `${ADMIN_PANEL_USERS}/:${USER_ID}/user-edit`,
    ADMIN_PANEL_USERS_CREATE = `${ADMIN_PANEL_USERS}/user-create`,
    ORGANIZATIONS = 'organizations',
    ADMIN_PANEL_ORGANIZATIONS = `admin-panel/${ORGANIZATIONS}`,
    ADMIN_PANEL_ORGANIZATIONS_CREATE = `${ADMIN_PANEL_ORGANIZATIONS}/organization-create`,
    ADMIN_PANEL_ORGANIZATION_DETAILS = `${ADMIN_PANEL_ORGANIZATIONS}/:${ORGANIZATION_ID}`,
    ADMIN_PANEL_ORGANIZATION_EDIT = `${ADMIN_PANEL_ORGANIZATION_DETAILS}/organization-edit`,
    ADMIN_PANEL_ORGANIZATION_USER_CREATE = `${ADMIN_PANEL_ORGANIZATION_DETAILS}/user-create`,
    ADMIN_PANEL_ORGANIZATION_USER_DETAILS = `${ADMIN_PANEL_ORGANIZATION_DETAILS}/${USERS}/:${USER_ID}`,
    ADMIN_PANEL_ORGANIZATION_DOCUMENT_CREATE = `${ADMIN_PANEL_ORGANIZATION_DETAILS}/documents/document-create`,
    ADMIN_PANEL_ORGANIZATION_DOCUMENT_EDIT = `${ADMIN_PANEL_ORGANIZATION_DETAILS}/documents/:${ORGANIZATION_DOCUMENT_ID}`,
    ADMIN_PANEL_DICTIONARIES = `admin-panel/${DICTIONARIES}`,
    ADMIN_PANEL_DICTIONARY_ADD_VALUE = `${ADMIN_PANEL_DICTIONARIES}/:${DICTIONARY_NAME}/dictionary-add-value`,
    ADMIN_PANEL_DICTIONARY_EDIT_VALUE = `${ADMIN_PANEL_DICTIONARIES}/:${DICTIONARY_NAME}/:${DICTIONARY_ITEM_ID}`,
    INCIDENTS = 'incidents',
    INCIDENT_DETAILS = `${Path.INCIDENTS}/:${INCIDENT_ID}`,
    INCIDENTS_CREATE = `${Path.INCIDENTS}/create-incident`,
    INCIDENTS_RESOLUTION = `${Path.INCIDENTS}/:${INCIDENT_ID}/resolution`,
    INCIDENTS_EDIT = `${Path.INCIDENTS}/:${INCIDENT_ID}/edit-incident`,
    INCIDENTS_CREATE_REFUND = `${Path.INCIDENTS}/:${INCIDENT_ID}/create-refund`,
    REFUNDS = 'refunds',
    TRANSACTIONS = 'transactions',
    REFUND_DETAILS = `refunds/:${REFUND_ID}`,
    REFUND_EDIT = `refunds/:${REFUND_ID}/edit-refund`,
    INCIDENTS_REFUND_DETAILS = `${Path.INCIDENT_DETAILS}/${Path.REFUND_DETAILS}`,
    INCIDENTS_REFUND_EDIT = `${Path.INCIDENT_DETAILS}/${Path.REFUND_EDIT}`,
    INCIDENTS_TRANSACTIONS_CREATE = `${Path.INCIDENT_DETAILS}/${Path.TRANSACTIONS}/create-transaction`,
    INCIDENTS_TRANSACTIONS_DETAILS = `${Path.INCIDENT_DETAILS}/${Path.TRANSACTIONS}/:${TRANSACTION_ID}`,
    INCIDENTS_TRANSACTIONS_EDIT = `${Path.INCIDENT_DETAILS}/${Path.TRANSACTIONS}/:${TRANSACTION_ID}/edit-transaction`,
    REFUNDS_TRANSACTIONS_DETAILS = `${Path.REFUND_DETAILS}/${Path.TRANSACTIONS}/:${TRANSACTION_ID}`,
    CONTACT_DETAILS = 'contact-details',
    INCIDENTS_CONTACT_DETAILS_CREATE = `${Path.INCIDENT_DETAILS}/${Path.CONTACT_DETAILS}/create`,
    INCIDENTS_CONTACT_DETAILS_DETAILS = `${Path.INCIDENT_DETAILS}/${Path.CONTACT_DETAILS}/:${CONTACT_DETAILS_ID}`,
    INCIDENTS_CONTACT_DETAILS_EDIT = `${Path.INCIDENT_DETAILS}/${Path.CONTACT_DETAILS}/:${CONTACT_DETAILS_ID}/edit`,
    MSISDN_FRAUD_ENTRIES = 'msisdn-fraud-entries',
    INCIDENTS_MSISDN_FRAUD_ENTRY_CREATE = `${Path.INCIDENT_DETAILS}/${Path.MSISDN_FRAUD_ENTRIES}/create`,
    INCIDENTS_MSISDN_FRAUD_ENTRY_EDIT = `${Path.INCIDENT_DETAILS}/${Path.MSISDN_FRAUD_ENTRIES}/:${MSISDN_FRAUD_ENTRY_ID}/edit`,
    SUBJECTS = 'subjects',
    SUBJECTS_CREATE = 'subjects/add',
    SUBJECTS_EDIT = `subjects/:${SUBJECT_ID}/edit`,
    SUBJECT_DETAILS = `subjects/:${SUBJECT_ID}`,
    SUBJECTS_CONTACT_DETAILS_DETAILS = `subjects/:${SUBJECT_ID}/${Path.CONTACT_DETAILS}/:${CONTACT_DETAILS_ID}`,
    INCIDENTS_SUBJECT_DETAILS = `${Path.INCIDENT_DETAILS}/${Path.SUBJECT_DETAILS}`,
    NOTIFICATIONS = 'notifications',
    OAUTH_CALLBACK = 'oauth/callback',
    AF_CENTRE = 'af-centre',
    MSISDN_DETAILS = `subjects/msisdn/:${MSISDN_ID}`,
    KNOWLEDGE_BASE = 'knowledge-base',
    FAQ = 'faq',
    FAQ_CREATE = `${Path.KNOWLEDGE_BASE}/${Path.FAQ}/create-faq`,
    FAQ_DETAILS = `${Path.KNOWLEDGE_BASE}/${Path.FAQ}/:${FAQ_ID}`,
    FAQ_EDIT = `${FAQ_DETAILS}/edit-faq`,
    DOCUMENTS = 'documents',
    VIEW_DOCUMENT = 'view-document',
    KNOWLEDGE_BASE_DOCUMENTS = `${Path.KNOWLEDGE_BASE}/${Path.DOCUMENTS}`,
    KNOWLEDGE_BASE_DOC_CREATE = `${Path.KNOWLEDGE_BASE_DOCUMENTS}/create-document`,
    KNOWLEDGE_BASE_DOC_DETAILS = `${Path.KNOWLEDGE_BASE_DOCUMENTS}/:${KNOWLEDGE_DOCUMENT_ID}`,
    KNOWLEDGE_BASE_DOC_EDIT = `${Path.KNOWLEDGE_BASE_DOC_DETAILS}/edit-document`,
    KNOWLEDGE_BASE_ARCHIVE = `${Path.KNOWLEDGE_BASE_DOCUMENTS}/archive`,
    KNOWLEDGE_BASE_DOC_VIEW = `${Path.KNOWLEDGE_BASE_DOCUMENTS}/${Path.VIEW_DOCUMENT}`,
}
